import $ from 'jquery';
import { redraw, frame } from '../../utils/drawing';
import { getScrollTop, getHeight } from '../../utils/window';
import { directiveSettings } from '../../utils/parse';

/**
 * Adds parallax to an element.
 *
 * Parallax with 75% speed: <div sw-parallax="0.75"></div>
 * Parallax for background images: <div sw-parallax='{"scale": true}'></div>
 *
 * @param context
 */
export default function parallaxDirective(context=document.body) {
    const $context = $(context);
    const $window = $(window);

    $context.find('[sw-parallax]').each(function() {
        const $element = $(this);
        const json = $element.attr('sw-parallax');
        const settings = directiveSettings(json, {
            speed: 0.5,
            align: 0.5,
			target: false,
            scale: false,
            reverse: false,
        }, 'speed');

		const $target = (settings.target && !settings.scale ? $(settings.target) : false);

        let height;
        let offset;
        let transform;

        function setup() {
            $element.css('transform', '');
            $element.css('transform-origin', 'top center');

            redraw($element);

            height = $element.outerHeight();
            offset = $element.offset();

            if (settings.scale) {
                const viewHeight = Math.min(getHeight(), offset.top + height);
                const newHeight = viewHeight - (viewHeight - height) * settings.speed;
                transform = `scale(${newHeight / height})`;
            } else {
                transform = '';
            }

            position();
        }

        function position() {
			const targetHeight = ($target ? $target.height() : getHeight());
            const scaleOffset = (targetHeight - height) * settings.align;
            const translate = (getScrollTop() - offset.top + scaleOffset) * (settings.speed - 1);

            var trans;

            if(settings.reverse) {
                trans = translate;
            } else {
                trans = -translate;
            }

            $element.css('transform', `translate3d(0, ${trans}px, 0) ${transform}`);
        }

        setup();
        $(() => frame(setup));
        $window.on('load resize', () => frame(setup));
        $window.on('scroll', () => frame(position));
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/parallax.js